import { Fragment, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { getLanguageKeysInForm } from '@components/form/dynamic-fields';
import { Spinner } from '@components/loading-spinner';
import { TooltipStyles } from '@components/tooltip';

import { useCompany } from 'api/company';
import { useForm } from 'api/form';
import { useVerifyDefaultLocale } from 'hooks/use-verify-default-locale';

import { DisplayForm } from './display-form';
import { FormLoadError } from './form-load-error';
import { Shell } from './shell';

type RootRouteParams = {
  company: string;
  id: string;
};

export const App = () => {
  const { company, id } = useParams() as RootRouteParams;
  const companyQuery = useCompany(company);
  const formQuery = useForm(id);

  useVerifyDefaultLocale(formQuery.data?.form);

  const languages = useMemo(() => {
    if (formQuery.data?.form) {
      return getLanguageKeysInForm(formQuery.data.form);
    }
    return [];
  }, [formQuery.data]);

  if (!companyQuery.isSuccess || formQuery.isLoading) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <TooltipStyles />
      <Shell languages={languages} company={companyQuery.data}>
        {formQuery.isSuccess && (
          <DisplayForm
            id={id}
            application={formQuery.data.application}
            form={formQuery.data.form}
          />
        )}
        {formQuery.isError && <FormLoadError />}
      </Shell>
    </Fragment>
  );
};
